import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import ListKontraktoPI from "../../components/ListKontraktoPI";
import Grid from '@mui/material/Grid';
import "./style.css";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import Post from "./Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Typography } from "@mui/material";

export default function CreatePost(){

    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [searchThis, setsearchThis] = useState("billTo")
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchPosts();
    }, [skip,query]);

    async function newPI(e){
        history("/PIListToPaidList",{state:{stuff:"new"}})

    }

    

    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis);
                    if(error){
                        console.log(error.message);
                        return;
                    }
        
                    if(data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }
                    
                    //success
                    setPosts([...posts, ...data])
                }catch(error){
                    console.log(error.message);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,query);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    const [fileURL, setFileURL] = useState("");


    const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const currid = post._id
    
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/previewpdfpaid?currid=${currid}&dbwhatToPreview=proformainvoiceDB`,{
            method: "GET",
            responseType: "blob"
        }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
                

            

        
        
        console.log("2")
    
    }

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value,searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...data])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }

    const searchSelected = async (event)=>{
        setsearchThis(event.target.value)
        if(query.trim()){
            try{
                const { data, error } = await read(skip,query,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            }
            }else{
                console.log("empty")
                try{
                    const { data, error } = await readEmpty(skip,query);
                    if(error){
                        console.log(error.message);
                        return;
                    }
        
                    if(data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }
                    
                    //success
                    setPosts([...posts, ...data])
                }catch(error){
                    console.log(error.message);
                } 
            }
    }
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/proformainvoice",{state:{data:post, stuff:"edit"}})
        }else{
            history("/proformainvoice",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const addonPI = async (post)=>{
        if(currPreview === "none"){
            history("/proformainvoice", {state:{data:post,stuff:"addOn"}})
        }else{
            history("/proformainvoice", {state:{data:currPreview,stuff:"addOn"}})
        }
    }

    const tidakButuh = () => {
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/tidakButuhKontrak`,{
            idtoEdit:currPreview._id, contractReq:"tidak"
        })
        .then(res => {
            window.location.reload();
        })
        .catch(err => {
            console.error(err);
        });
    }

    const [openListKontrak, setOpenListKontrak] = useState(false)

    return <Grid sx={12} container>
                <Dialog open={openListKontrak} onClose={(event)=>setOpenListKontrak(false)}>
                    <ListKontraktoPI invoicetoLink={currPreview}></ListKontraktoPI>
                </Dialog>
                    <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container>
                        <Grid xs={6}>
                        <iframe src={`${fileURL}#zoom=70`} width="600" height="500"></iframe>
                        </Grid>
                        <Grid xs={1}></Grid>
                        <Grid xs={5}>
                            <Grid xs={12} sx={{mt:5}}>
                            <Button variant="contained" color="success" onClick={()=>navigate("/Kontrak")}>Buat Kontrak</Button>
                            </Grid>
                            <Grid xs={12} sx={{mt:5}}>
                            <Button variant="contained" onClick={(event)=> setOpenListKontrak(true)}>Sudah pernah buat Kontrak</Button>
                            </Grid>
                            <Grid xs={12} sx={{mt:5}}>
                            <Button variant="contained" color="error" onClick={tidakButuh}>Tidak Butuh Kontrak</Button>
                            </Grid>
                        </Grid>
                        </Grid>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    </DialogActions>
                </Dialog>
 
                    <Grid  sx={12} container>
                            <Grid sx={12} container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 350, minHeight: 350 }} style={{ overflow: 'auto',   // Thick Border
      boxShadow: '5px 5px 7px grey'}} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell >
                                                    Tanggal
                                                </TableCell>
                                                <TableCell>
                                                    Bill
                                                </TableCell>
                                                <TableCell>
                                                    Ship
                                                </TableCell>
                                                <TableCell>
                                                    Nomor
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover sx={{
            '&:hover': {
                backgroundColor: 'rgba(255, 83, 46,1) !important',
            },
            backgroundColor: 'red',
            height:"10px",
        }}>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer',padding: '10px 16px', lineHeight: '0.8'}}>
                                                        <p>{post.tanggalPI}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer',padding: '10px 16px', lineHeight: '0.8'}}>
                                                        <p>{post.billTo}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer',padding: '10px 16px', lineHeight: '0.8'}}>
                                                        <p>{post.shipTo}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer',padding: '10px 16px', lineHeight: '0.8'}}>
                                                        <p>{post.piAmount}</p>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
    };

